import React from "react";
import { connect } from "react-redux";

class Url extends React.Component {
  render() {
    console.log("ValidationResult:", this.props.validationResult);
    console.log("URL:", this.props.url);
    const url = this.props.validationResult.isValid && this.props.url;

    return <div className="wizard-url">{url}</div>;
  }
}

const mapStateToProps = (state) => ({
  validationResult: state.step2Validation.NameValid,
  url: state.newSite.Url,
});

export default connect(mapStateToProps, null)(Url);



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Url.js